import Quill from "quill";

import {
  isDirectBoardDocumentVideoUrl,
  normalizeBoardDocumentVideoUrl,
} from "./boardDocumentUtils";

const QuillVideo = Quill.import("formats/video");
const BlockEmbed = Quill.import("blots/block/embed");

class BoardDocumentVideo extends BlockEmbed {
  static create(value) {
    const normalizedUrl = this.sanitize(value);

    if (isDirectBoardDocumentVideoUrl(normalizedUrl)) {
      const node = document.createElement("video");
      node.setAttribute("src", normalizedUrl);
      node.setAttribute("controls", "controls");
      node.setAttribute("playsinline", "playsinline");
      node.classList.add(this.className);
      return node;
    }

    const node = document.createElement("iframe");
    node.setAttribute("frameborder", "0");
    node.setAttribute("allowfullscreen", true);
    node.setAttribute("src", normalizedUrl);
    node.classList.add(this.className);
    return node;
  }

  static sanitize(url) {
    return QuillVideo.sanitize(normalizeBoardDocumentVideoUrl(url));
  }

  static value(domNode) {
    return domNode.getAttribute("src");
  }
}

BoardDocumentVideo.blotName = "video";
BoardDocumentVideo.className = "ql-video";
BoardDocumentVideo.tagName = ["IFRAME", "VIDEO"];

let isBoardDocumentVideoRegistered = false;

export function registerBoardDocumentVideoBlot() {
  if (isBoardDocumentVideoRegistered) {
    return;
  }

  Quill.register(BoardDocumentVideo, true);
  isBoardDocumentVideoRegistered = true;
}
